/* eslint-disable */
export default {
  SET_ROLE_PERMISSIONS(state, data) {
    state.rolePermissions = data;
  },
};
